"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var progress_spinner_1 = require("@angular/material/progress-spinner");
var core_1 = require("@angular/core");
var LoadImageDirective = /** @class */ (function () {
    function LoadImageDirective(renderer, el, componentFactoryResolver, viewContainerRef) {
        var _this = this;
        this.renderer = renderer;
        this.el = el;
        this.componentFactoryResolver = componentFactoryResolver;
        this.viewContainerRef = viewContainerRef;
        this.backgroundSrc = null;
        this.setImage = function () {
            _this.renderer.setStyle(_this.el.nativeElement, 'background-image', 'url(' + _this.backgroundSrc + ')');
        };
        this.spinnerFactory = this.componentFactoryResolver.resolveComponentFactory(progress_spinner_1.MatProgressSpinner);
    }
    LoadImageDirective.prototype.ngOnInit = function () {
        var _this = this;
        var img = new Image();
        /// set handler and url
        img.onload = function () {
            _this.setImage();
            _this.destroySpinner();
        };
        img.src = this.backgroundSrc;
        this.createSpinner();
    };
    LoadImageDirective.prototype.createSpinner = function () {
        if (!this.spinner) {
            this.spinner = this.viewContainerRef.createComponent(this.spinnerFactory);
            this.spinner.instance.diameter = 20;
            this.spinner.instance.mode = 'indeterminate';
            this.renderer.appendChild(this.el.nativeElement, this.spinner.instance._elementRef.nativeElement);
        }
    };
    LoadImageDirective.prototype.destroySpinner = function () {
        if (this.spinner) {
            this.spinner.destroy();
            this.spinner = null;
        }
    };
    return LoadImageDirective;
}());
exports.LoadImageDirective = LoadImageDirective;
